import { useQuery } from '@apollo/client/react';
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import dayjs from 'dayjs';
import { titleize } from 'inflection';
import { map } from 'lodash';
import { useContext } from 'react';

import CurrentUserContext from '@/Contexts/CurrentUser';
import { ReportContext } from '@/Contexts/ReportContext';
import { GetReportIssuesDocument } from '@/graphql/generated/graphql';
import { objectLength } from '@/utils/helperFunctions';

const DiaryEntries = () => {
  const { dateTimePreference } = useContext(CurrentUserContext);
  const { selectedReport } = useContext(ReportContext);
  const { data } = useQuery(GetReportIssuesDocument, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !selectedReport?.id,
    variables: {
      reportId: selectedReport?.id as string,
    },
  });

  return (
    <TableContainer component={Paper} elevation={1}>
      <Box sx={{ p: 2, bgcolor: '#e3f2fd' }}>
        <Typography variant="h6" sx={{ color: '#0d47a1', fontWeight: 600 }}>
          Diary Entries
        </Typography>
      </Box>

      {objectLength(data?.getReportIssues) === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">No diary entries recorded for the date.</Typography>
        </Box>
      ) : (
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Start</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>End</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {map(data?.getReportIssues, (row, index) => (
              <TableRow key={index} hover>
                <TableCell>{dayjs(row?.startTime).format(dateTimePreference.time)}</TableCell>
                <TableCell>{dayjs(row?.endTime).format(dateTimePreference.time)}</TableCell>
                <TableCell sx={{ fontWeight: 500 }}>{titleize(row?.issueType)}</TableCell>
                <TableCell sx={{ fontWeight: 500 }}>
                  <Typography variant="body2" dangerouslySetInnerHTML={{ __html: row.description }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default DiaryEntries;
